import { Search, Loader2 } from "lucide-react";
import { AccountCard } from "./account_card";
import { useNavigate } from "react-router-dom";
import type { UserProfile } from "../models/UserProfile";

interface AccountsGridProps {
  loading: boolean;
  error: Error | null;
  accounts: UserProfile[];
  selectedIds: string[];
  toggleSelection: (id: string) => void;
  onViewPlan?: (account: UserProfile) => void;
  /** id de la cuenta con un correo en curso. */
  sendingMailId?: string | null;
  onResendConfirmation?: (account: UserProfile) => void;
  onSendPasswordReset?: (account: UserProfile) => void;
}

export function AccountsGrid({
  loading,
  error,
  accounts,
  selectedIds,
  toggleSelection,
  onViewPlan,
  sendingMailId,
  onResendConfirmation,
  onSendPasswordReset,
}: AccountsGridProps) {
  const navigate = useNavigate();

  return (
    <div className="mt-8">
      {loading && (
        <div className="flex justify-center py-20">
          <Loader2 className="size-10 animate-spin text-accent" />
        </div>
      )}
      {error && (
        <div className="text-center py-20 text-red-500">
          <p>Error al cargar las cuentas: {error.message}</p>
        </div>
      )}
      {!loading && !error && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
          {accounts.map((account) => (
            <AccountCard
              key={account.id}
              id={account.id}
              name={account.name}
              email={account.email}
              role={account.role}
              emailConfirmed={account.emailConfirmed}
              sendingMail={sendingMailId === account.id}
              selected={selectedIds.includes(account.id)}
              onSelect={() => toggleSelection(account.id)}
              onEdit={() => navigate(account.id)}
              onViewPlan={() => onViewPlan?.(account)}
              onResendConfirmation={() => onResendConfirmation?.(account)}
              onSendPasswordReset={() => onSendPasswordReset?.(account)}
            />
          ))}
          {accounts.length === 0 && (
            <div className="col-span-full py-32 rounded-3xl border border-dashed border-white/10 flex flex-col items-center justify-center text-accent/20">
              <Search className="size-12 mb-4 opacity-10" />
              <p className="text-lg font-medium">No se encontraron cuentas</p>
              <p className="text-sm">
                Prueba ajustando los filtros o el término de búsqueda.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
